export default [
  {
    path: '/pvh/status/list',
    name: 'PvhStatusList',
    component: () => import('@/views/Pvh/PvhStatusList.vue')
  },
  {
    path: '/pvh/status/update/:id',
    name: 'PvhStatusUpdate',
    component: () => import('@/views/Pvh/PvhStatusUpdate.vue'),
    redirect: {
      name: 'PvhStatusUpdate_statusTab'
    },
    children: [
      {
        path: 'status',
        name: 'PvhStatusUpdate_statusTab',
        component: () => import('@/components/pvh/PvhStatusUpdateStatuses')
      },
      {
        path: 'role',
        name: 'PvhStatusUpdate_roleTab',
        component: () => import('@/components/pvh/PvhStatusUpdateRoles')
      },
      {
        path: 'fields',
        name: 'PvhStatusUpdate_fieldsTab',
        component: () => import('@/components/pvh/PvhStatusUpdateFields')
      },
      {
        path: 'notification',
        name: 'PvhStatusUpdate_notificationTab',
        component: () => import('@/components/pvh/PvhStatusUpdateNotification')
      }
    ]
  }
]
